window.TX = window.TX || function (k, d) { var t = window.CT_TEXT || {}; return t[k] || d; };
var TX = window.TX;
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Entrance video: fade in once it actually plays; stay on the still image for reduced motion.
  document.querySelectorAll('.cx-hero__video').forEach(function (v) {
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
    v.muted = true;
    var on = function () { v.classList.add('is-playing'); };
    v.addEventListener('playing', on, { once: true });
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function () {});
  });

  // Tabs
  document.querySelectorAll('.cx-tabs[role="tablist"]').forEach(function (list) {
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    function select(t) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(x.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!n) return;
        e.preventDefault();
        var next = tabs[(i + n + tabs.length) % tabs.length];
        select(next); next.focus();
      });
    });
  });

  // Review carousel arrows
  document.querySelectorAll('[data-cx-reviews]').forEach(function (sec) {
    var list = sec.querySelector('.cx-reviews__list');
    sec.querySelectorAll('.cx-rbtn').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = list.querySelector('.cx-review');
        var step = card ? card.getBoundingClientRect().width + 24 : 300;
        list.scrollBy({ left: step * Number(b.dataset.dir), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  });

  // Smooth in-page anchors
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a) return;
    var url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
    var el = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    history.replaceState(null, '', url.hash);
  });
})();


// Open Horizon's cart drawer with fresh contents; fall back to the cart page.
// ---------- Assortion is the cart drawer: never let the theme's own (modal) cart drawer open on top ----------
// The theme drawer is a modal <dialog>; when it opens behind Assortion it makes the whole page, incl. Assortion, unclickable.
window.cxAssortion = function () {
  return !!(window.Assortion || document.querySelector('script[src*="assortion"], .ast-cart'));
};
window.cxCloseThemeDrawer = function () {
  document.querySelectorAll('dialog.cart-drawer__dialog[open], cart-drawer-component dialog[open]').forEach(function (d) {
    try { d.close(); } catch (e) { d.removeAttribute('open'); }
  });
  document.documentElement.classList.remove('dialog-open', 'overflow-hidden');
  document.body.classList.remove('dialog-open', 'overflow-hidden');
};
(function () {
  function watch() {
    document.querySelectorAll('dialog.cart-drawer__dialog, cart-drawer-component dialog').forEach(function (d) {
      if (d.__cxWatch) return; d.__cxWatch = true;
      new MutationObserver(function () {
        if (d.open && window.cxAssortion()) setTimeout(window.cxCloseThemeDrawer, 0);
      }).observe(d, { attributes: true, attributeFilter: ['open'] });
      if (d.open && window.cxAssortion()) window.cxCloseThemeDrawer();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  new MutationObserver(function () { watch(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

window.cxAfterAdd = function () {
  var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  var drawer = document.querySelector('cart-drawer-component');
  if (!drawer) { window.location.href = base + 'cart'; return Promise.resolve(); }
  return fetch(base + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    var ev = new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'cx-product', data: { source: 'cx-product', itemCount: cart.item_count } } });
    document.dispatchEvent(ev);
    if (window.cxAssortion()) { window.cxCloseThemeDrawer(); return; }
    if (!drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') drawer.open();
  }).catch(function (e) { console.warn('cx cart drawer', e); window.location.href = base + 'cart'; });
};

// ---------- Product page ----------
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-cx-gal]').forEach(function (g) {
    var track = g.querySelector('[data-cx-track]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-go]'));
    if (!track) return;
    function go(i) {
      var n = track.children.length;
      i = (i + n) % n;
      track.scrollTo({ left: track.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
    }
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.go)); }); });
    g.querySelectorAll('.cx-gal__nav').forEach(function (b) { b.addEventListener('click', function () { go(current() + Number(b.dataset.dir)); }); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var c = current();
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === c); });
      });
    });
  });

  document.querySelectorAll('[data-cx-pdp]').forEach(function (root) {
    var form = root.querySelector('[data-cx-form]');
    if (!form) return;
    var fmt = root.dataset.moneyFormat || '{{amount_with_comma_separator}} kr';
    var discount = Number(root.dataset.discount || 0);
    var baseId = root.dataset.baseId;
    var basePrice = Number(root.dataset.basePrice);
    var baseTitle = root.dataset.baseTitle;
    var baseImg = root.dataset.baseImg;
    var totalEl = root.querySelector('[data-cx-total]');
    var compareEl = root.querySelector('[data-cx-compare]');
    var labelEl = root.querySelector('[data-cx-sumlabel]');
    var noteEl = root.querySelector('[data-cx-bnote]');
    var pack = root.querySelector('[data-cx-pack]');
    var kit2 = root.querySelector('[data-cx-kit2]');
    var qty = root.querySelector('[data-cx-qty]');
    var addon = root.querySelector('[data-cx-addon]');
    var err = root.querySelector('[data-cx-error]');
    var btn = root.querySelector('[data-cx-submit]');
    var offerForm = root.dataset.offerForm;
    var offerNote = root.querySelector('[data-cx-offernote]');
    var deal = root.querySelector('[data-cx-deal]');
    var sumWraps = root.querySelectorAll('[data-cx-sumwrap]');
    var flag = root.querySelector('[data-cx-unlocked-flag]');
    var freeInput = root.querySelector('[data-cx-free]');
    var ctaDefault = btn ? btn.textContent : '';
    var KEY = 'cx_offer_unlocked';
    function isOffer() { var r = root.querySelector('[data-cx-plan]:checked'); return !!(r && r.value === 'offer'); }
    function unlocked() {
      try { if (/[?&]tilbud=1\b/.test(location.search)) localStorage.setItem(KEY, '1'); return localStorage.getItem(KEY) === '1'; } catch (e) { return /[?&]tilbud=1\b/.test(location.search); }
    }
    function unlock() { try { localStorage.setItem(KEY, '1'); } catch (e) {} update(); }
    var klOpened = false;
    function openKlaviyo() {
      klOpened = false;
      var fail = root.querySelector('[data-cx-klfail]');
      if (fail) fail.hidden = true;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', offerForm]);
      setTimeout(function () { if (!klOpened && fail) fail.hidden = false; }, 2000);
    }
    if (offerForm) {
      window.addEventListener('klaviyoForms', function (e) {
        var d = e.detail || {};
        if (String(d.formId) !== offerForm) return;
        if (d.type === 'open') { klOpened = true; var f = root.querySelector('[data-cx-klfail]'); if (f) f.hidden = true; }
        if (d.type === 'submit' || d.type === 'stepSubmit') unlock();
      });
    }
    function money(cents) {
      var n = (cents / 100).toFixed(2);
      var parts = n.split('.');
      var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        if (k === 'amount_with_comma_separator') return withDots + ',' + parts[1];
        if (k === 'amount_no_decimals_with_comma_separator') return withDots;
        if (k === 'amount_no_decimals') return withCommas;
        if (k === 'amount_with_period_and_space_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '.' + parts[1];
        return withCommas + '.' + parts[1];
      });
    }
    function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
    function plan() { var r = root.querySelector('[data-cx-plan]:checked'); return r && r.value !== 'offer' ? Number(r.value) : 1; }
    function second() { return root.querySelector('input[name="cx-kit2"]:checked'); }
    function q() { return qty ? Math.min(20, Math.max(1, parseInt(qty.value, 10) || 1)) : 1; }
    function lines() {
      var l = [];
      if (plan() === 2 && second()) {
        var s2 = second();
        if (s2.value === baseId) l.push({ id: baseId, qty: 2, price: basePrice, title: baseTitle, img: baseImg });
        else {
          l.push({ id: baseId, qty: 1, price: basePrice, title: baseTitle, img: baseImg });
          l.push({ id: s2.value, qty: 1, price: Number(s2.dataset.price), title: s2.dataset.title, img: s2.dataset.img });
        }
      } else {
        l.push({ id: baseId, qty: q(), price: basePrice, title: baseTitle, img: baseImg });
      }
      if (addon && addon.checked) l.push({ id: addon.value, qty: 1, price: Number(addon.dataset.price), title: addon.dataset.title, img: addon.dataset.img });
      return l;
    }
    function update() {
      var l = lines();
      var full = l.reduce(function (a, x) { return a + x.price * x.qty; }, 0);
      var bundled = plan() === 2 && second();
      var total = bundled ? full - discount : full;
      if (kit2) kit2.hidden = plan() !== 2;
      if (totalEl) totalEl.textContent = money(total);
      if (compareEl) { compareEl.hidden = !bundled; compareEl.textContent = money(full); }
      if (noteEl) noteEl.hidden = !bundled;
      if (labelEl) labelEl.textContent = bundled ? ((window.CT_TEXT || {}).bundle || '2 HomeKit · spar') + ' ' + money(discount).replace(/[,.]00(?=\D|$)/, '') : (q() > 1 ? q() + ' × ' + baseTitle : baseTitle);
      if (pack) {
        pack.innerHTML = l.map(function (x) {
          return '<li class="cx-pack__item"><span class="cx-pack__img">' + (x.img ? '<img src="' + x.img + '" alt="" width="50" height="50">' : '') + '</span><span><span class="cx-pack__name">' + (x.qty > 1 ? x.qty + ' × ' : '') + esc(x.title) + '</span><span class="cx-pack__val">' + money(x.price * x.qty) + '</span></span></li>';
        }).join('');
      }
      if (offerForm) {
        var on = isOffer(), open = unlocked();
        if (deal) deal.hidden = !on;
        sumWraps.forEach(function (el) { el.hidden = on; });
        if (flag) flag.hidden = !open;
        root.classList.toggle('is-unlocked', open);
        if (btn && !btn.hasAttribute('aria-busy')) {
          btn.textContent = on ? (open ? (root.dataset.offerCtaOpen || TX('ctaOpen', 'Læg pakken i kurv')) : (root.dataset.offerCta || TX('ctaOffer', 'Få adgang til tilbuddet'))) : ctaDefault;
          btn.classList.toggle('cx-buy__cta--lock', on && !open);
        }
        if (offerNote) offerNote.hidden = !(on && !open);
      }
    }
    root.addEventListener('change', update);
    root.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.min(20, Math.max(1, q() + Number(b.dataset.step))); update(); });
    });
    if (qty) qty.addEventListener('input', update);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (offerForm && isOffer()) {
        if (!unlocked()) { openKlaviyo(); return; }
        if (err) err.hidden = true;
        btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
        var root0 = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        var fd = freeInput ? freeInput.dataset : {};
        var props = {};
        props[TX('pOffer', 'Tilbud')] = TX('offerLine', '{{ pack }}: −{{ pct }}% på HomeKit').replace('{{ pack }}', fd.pack || TX('pack', 'Pakke')).replace('{{ pct }}', fd.pct || '10');
        props[TX('pGift', 'Gratis tilskud')] = fd.gift || TX('giftFallback', 'Skræddersyet kosttilskud, 3 måneders forbrug');
        props[TX('pValue', 'Værdi')] = fd.value || '';
        props[TX('pDelivery', 'Levering af tilskud')] = fd.delivery || TX('deliveryText', 'Sendes nogle dage efter analysen');
        props[TX('pSaving', 'Samlet besparelse')] = fd.save || '';
        var its = [{ id: Number(baseId), quantity: 1, properties: props }];
        var codes = (root.dataset.offerCodes || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
        fetch(root0 + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: its }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return fetch(root0 + 'cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            var have = (cart.discount_codes || []).map(function (d) { return d.code; });
            codes.forEach(function (c) { if (have.indexOf(c) === -1) have.push(c); });
            if (!codes.length) return null;
            return fetch(root0 + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: have.join(',') }) });
          })
          .then(function () { return window.cxAfterAdd(); }).then(function () { btn.removeAttribute('aria-busy'); btn.disabled = false; update(); })
          .catch(function () { if (err) err.hidden = false; btn.removeAttribute('aria-busy'); btn.disabled = false; });
        return;
      }
      if (err) err.hidden = true;
      btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
      var cxProps = {};
      form.querySelectorAll('input[name^="properties["]').forEach(function (i) {
        cxProps[i.name.slice(11, -1)] = i.value;
      });
      var cxHas = Object.keys(cxProps).length > 0;
      var items = lines().map(function (x) {
        var it = { id: Number(x.id), quantity: x.qty };
        if (cxHas && String(x.id) === String(baseId)) it.properties = cxProps;
        return it;
      });
      var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      fetch(base + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (d) {
          if (d && d.status === 'blocked') return;
          throw new Error('add failed');
        });
        form.querySelectorAll('.cow-hidden-props').forEach(function (i) { i.remove(); });
        return window.cxAfterAdd();
      }).then(function () { btn.removeAttribute('aria-busy'); btn.disabled = false; }).catch(function () {
        if (err) err.hidden = false;
        btn.removeAttribute('aria-busy'); btn.disabled = false;
      });
    });
    update();
  });
})();

// ---------- Cart drawer (Assortion app): show the free supplement as a gift ----------
(function () {
  function props(box) {
    var o = {};
    box.querySelectorAll('.ast-cart__item__property').forEach(function (p) {
      var k = (p.querySelector('.ast-cart__item__property-name') || {}).textContent || '';
      var v = (p.querySelector('.ast-cart__item__property-value') || {}).textContent || '';
      o[k.replace(/:\s*$/, '').trim()] = v.trim();
    });
    return o;
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  function decorate() {
    document.querySelectorAll('.ast-cart__item__properties:not([data-cx-done])').forEach(function (box) {
      var o = props(box);
      if (!o[TX('pGift', 'Gratis tilskud')]) return;
      box.setAttribute('data-cx-done', '');
      var g = document.createElement('div');
      g.className = 'cx-cartgift cx-cartgift--drawer';
      g.innerHTML = '<span class="cx-cartgift__row"><span class="cx-cartgift__tag">' + esc(TX('giftTag', 'Gratis')) + '</span><span class="cx-cartgift__worth">' + esc(TX('worth', 'Værdi')) + ' ' + esc(o[TX('pValue', 'Værdi')] || '') + '</span></span>' +
        '<span class="cx-cartgift__text"><strong>' + esc(o[TX('pGift', 'Gratis tilskud')]) + '</strong></span>' +
        '<span class="cx-cartgift__value">' + esc(o[TX('pDelivery', 'Levering af tilskud')] || '') + '</span>';
      box.parentNode.insertBefore(g, box);
      box.classList.add('cx-visually-hidden');
    });
  }
  // Savings panel above the drawer subtotal, calculated from the real cart (discounts + value of free supplements)
  function kr(c) { return (c / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr'; }
  function val(t) { var n = parseFloat(String(t || '').replace(/kr/i, '').replace(/\./g, '').replace(',', '.').trim()); return isNaN(n) ? 0 : Math.round(n * 100); }
  var sig = '', busy = false, last = null;
  function render(wrap, cart) {
    var gift = 0, titles = [];
    (cart.items || []).forEach(function (it) {
      var pr = it.properties || {};
      if (pr[TX('pGift', 'Gratis tilskud')] && pr[TX('pValue', 'Værdi')]) gift += val(pr[TX('pValue', 'Værdi')]) * it.quantity;
      (it.line_level_discount_allocations || []).forEach(function (a) { var ti = a.discount_application && a.discount_application.title; if (ti && titles.indexOf(ti) === -1) titles.push(ti); });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) { if (a.title && titles.indexOf(a.title) === -1) titles.push(a.title); });
    var disc = cart.total_discount || 0, total = disc + gift;
    var el = wrap.parentNode.querySelector('.cx-save');
    if (!total) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('div'); el.className = 'cx-save cx-save--drawer'; el.setAttribute('role', 'status'); wrap.parentNode.insertBefore(el, wrap); }
    el.innerHTML = '<div class="cx-save__head"><span class="cx-save__label">' + esc(TX('savings', 'Din besparelse')) + '</span><strong class="cx-save__total">' + kr(total) + '</strong></div>' +
      '<ul class="cx-save__rows" role="list">' +
      (disc ? '<li><span>' + esc(TX('discount', 'Rabat')) + (titles.length ? ' (' + esc(titles.join(', ')) + ')' : '') + '</span><span>−' + kr(disc) + '</span></li>' : '') +
      (gift ? '<li><span>' + esc(TX('giftValue', 'Gratis skræddersyet tilskud (værdi)')) + '</span><span>' + kr(gift) + '</span></li>' : '') + '</ul>';
  }
  function savings() {
    var wrap = document.querySelector('.ast-cart__price-wrapper');
    if (!wrap) return;
    var sub = (wrap.querySelector('.ast-cart__subtotal__price') || {}).textContent || '';
    var count = document.querySelectorAll('.ast-cart__item').length;
    var s = sub + '|' + count + '|' + document.querySelectorAll('.ast-cart__item .ast-quantity input, .ast-cart__item [class*=quantity] input').length;
    if (s === sig && last) { if (!wrap.parentNode.querySelector('.cx-save')) render(wrap, last); return; }
    if (busy) return; busy = true;
    var root0 = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    fetch(root0 + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) { sig = s; last = cart; var w = document.querySelector('.ast-cart__price-wrapper'); if (w) render(w, cart); })
      .catch(function () {}).then(function () { busy = false; });
  }
  var t;
  function run() { decorate(); savings(); }
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 80); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  run();
})();

// Header dropdowns: one open at a time, close on outside click / Escape
(function () {
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.ct-dd details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.ct-dd details[open]').forEach(function (d) { d.removeAttribute('open'); });
  });
  document.addEventListener('toggle', function (e) {
    if (!e.target.matches || !e.target.matches('.ct-dd details') || !e.target.open) return;
    document.querySelectorAll('.ct-dd details[open]').forEach(function (d) { if (d !== e.target) d.removeAttribute('open'); });
  }, true);
})();

// Front page: rotate background images
(function () {
  document.querySelectorAll('[data-cx-slides]').forEach(function (box) {
    var slides = [].slice.call(box.querySelectorAll('.cx-hero__slide'));
    if (slides.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ms = parseInt(box.dataset.interval, 10) || 5000, i = 0, t;
    slides.forEach(function (s) { var im = s.querySelector('img'); if (im) im.loading = 'eager'; });
    function next() {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      var img = slides[i].querySelector('img');
      if (img) { img.style.animation = 'none'; void img.offsetWidth; img.style.animation = ''; }
      slides[i].classList.add('is-active');
    }
    function start() { stop(); t = setInterval(next, ms); }
    function stop() { if (t) clearInterval(t); }
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  });
})();

// Booking (Cowlendar): when the booking calendar opens, keep the Assortion cart drawer closed so it doesn't cover the time slots
(function () {
  function calendarOpen() {
    var c = document.querySelector('.cowlendar-root, .cowlendar-bg');
    if (!c) return false;
    var cs = getComputedStyle(c);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && c.offsetWidth > 0;
  }
  function closeAst() {
    var btn = document.querySelector('.ast-cart.ast-open .ast-cart__close, .ast-cart.ast-open button[aria-label*="lose"], .ast-cart.ast-open button[aria-label*="Luk"]');
    if (btn) btn.click();
  }
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () {
      if (document.querySelector('.ast-cart.ast-open') && calendarOpen()) closeAst();
    }, 50);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
})();
